import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const { FiTarget, FiShield, FiWind, FiArrowRight, FiCheck } = FiIcons;

const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 1, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Training() {
  const pillars = [
    { title: "Seek Clarity", desc: "Find focus and peace amidst life's distractions through guided mindfulness.", icon: FiWind },
    { title: "Build Strength", desc: "Develop physical and mental resilience that carries you through any storm.", icon: FiShield },
    { title: "Achieve Alignment", desc: "Align your body, mind, and spirit with your higher purpose.", icon: FiTarget }
  ];

  return (
    <div className="w-full bg-kin-black">
      <section className="relative min-h-[90vh] flex items-center justify-center px-6 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="https://images.unsplash.com/photo-1545201071-75f058cca503?auto=format&fit=crop&q=80&w=2000" alt="Meditation" className="w-full h-full object-cover opacity-20 grayscale" />
          <div className="absolute inset-0 bg-gradient-to-b from-kin-black via-kin-black/60 to-kin-black"></div>
        </div>
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <FadeUp> <p className="text-kin-gold tracking-[0.4em] text-xs uppercase font-light mb-10"> Free Training Series </p> </FadeUp>
          <FadeUp delay={0.2}> <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-kin-ivory mb-12 leading-[1.05]"> Strength, Yoga, & <br /> <span className="italic text-kin-gold font-normal">Meditation.</span> </h1> </FadeUp>
          <FadeUp delay={0.4}>
            <Link to="/contact">
              <Button variant="primary" className="px-16 py-6 text-sm"> Access Free Training </Button>
            </Link>
          </FadeUp>
        </div>
      </section>

      <section className="py-40 md:py-60 px-6 text-center border-t border-kin-ivory/5 relative overflow-hidden bg-kin-black">
        <div className="max-w-4xl mx-auto relative z-10">
          <FadeUp> <h2 className="text-4xl md:text-6xl font-serif text-kin-ivory mb-12 leading-tight"> Ready to begin your <br /> <span className="text-kin-gold italic">inward journey?</span> </h2> </FadeUp>
          <FadeUp delay={0.2}>
            <Link to="/contact">
              <Button variant="primary" className="px-16 py-6 text-sm"> Unlock Full Training </Button>
            </Link>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}